import React from "react";
import { Card, CardBody, CardTitle, CardText, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";

function ProductCard({ title, description, icon, link, to }) {
  const navigate = useNavigate();
  return (
    <Card className="product-card h-100">
      {icon && (
        <div className="product-card-icon-wrap">
          <img src={icon} alt={`${title} icon`} className="product-card-icon" />
        </div>
      )}
      <CardBody className="d-flex flex-column">
        <CardTitle tag="h5" className="product-card-title">
          {title}
        </CardTitle>
        <CardText className="product-card-text flex-grow-1">{description}</CardText>
        <Button
          color="success"
          className="mt-2 product-card-btn"
          onClick={() => {
            if (to) {
              navigate(to);
            } else if (link) {
              window.open(link, "_blank");
            }
          }}
        >
          Open Product
        </Button>
      </CardBody>
    </Card>
  );
}

export default ProductCard;
